<div class="unsub-card">
	<div class="unsub-toprow">
		<a routerLink="/login" class="unsub-back">
			<svg
				width="14"
				height="14"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2.2"
				stroke-linecap="round"
				stroke-linejoin="round"
				aria-hidden="true">
				<path d="M19 12H5" />
				<path d="m12 5-7 7 7 7" />
			</svg>
			{{ Dic.backtologin.text }}
		</a>
		<div class="unsub-lang">
			<button type="button" class="unsub-lang-btn" [class.unsub-lang-btn--active]="currentLang === 'fr'" (click)="setLanguage('fr')">
				FR
			</button>
			<span class="unsub-lang-sep">|</span>
			<button type="button" class="unsub-lang-btn" [class.unsub-lang-btn--active]="currentLang === 'en'" (click)="setLanguage('en')">
				EN
			</button>
		</div>
	</div>

	<div class="unsub-brand">
		<div class="unsub-brand-logo">
			@if (appIcon) {
			<img [src]="appIcon" alt="Logo" class="unsub-brand-img" />
			} @else {
			<span class="unsub-brand-initial">C</span>
			}
		</div>
	</div>

	@switch (state()) { @case ('loading') {
	<h1 class="unsub-title">{{ Dic.unsubscribe.text }}</h1>
	<div class="unsub-loading">
		<svg
			class="unsub-spinner"
			width="22"
			height="22"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="2.5"
			stroke-linecap="round">
			<path d="M12 2a10 10 0 0 1 10 10" />
		</svg>
	</div>
	} @case ('confirm') {
	<h1 class="unsub-title">{{ Dic.unsubscribe.text }}</h1>
	<p class="unsub-description">
		{{ Dic.hello.text }}, {{ userName() }}
		<br />
		<span class="unsub-description-caption">({{ userEmail() }})</span>
	</p>
	@if (queryMessage()) {
	<p class="unsub-subtitle">{{ queryMessage() }}</p>
	}
	<div class="unsub-actions">
		<a routerLink="/login" class="unsub-btn unsub-btn--cancel">{{ Dic.cancel.text }}</a>
		<button type="button" class="unsub-btn unsub-btn--confirm" [disabled]="confirming()" (click)="confirm()">
			@if (confirming()) {
			<svg
				class="unsub-spinner"
				width="16"
				height="16"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2.5"
				stroke-linecap="round">
				<path d="M12 2a10 10 0 0 1 10 10" />
			</svg>
			} {{ Dic.confirm.text }}
		</button>
	</div>
	} @case ('success') {
	<div class="unsub-success-icon" aria-hidden="true">
		<svg
			width="40"
			height="40"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round">
			<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
			<polyline points="22 4 12 14.01 9 11.01" />
		</svg>
	</div>
	<h1 class="unsub-title">{{ Dic.unsubscribe_done.text }}</h1>

	@if (successMessage()) {
	<p class="unsub-subtitle unsub-subtitle--sent">{{ successMessage() }}</p>
	}
	<a routerLink="/login" class="unsub-btn-primary unsub-back-btn">{{ Dic.backtologin.text }}</a>
	} @case ('error') {
	<h1 class="unsub-title">{{ Dic.error.text }}</h1>
	<div class="unsub-banner" role="alert">
		<svg
			width="14"
			height="14"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="2.2"
			stroke-linecap="round"
			stroke-linejoin="round"
			class="shrink-0 mt-px">
			<circle cx="12" cy="12" r="10" />
			<line x1="12" y1="8" x2="12" y2="12" />
			<line x1="12" y1="16" x2="12.01" y2="16" />
		</svg>
		<span>{{ errorMessage() }}</span>
	</div>
	<a routerLink="/login" class="unsub-btn-primary unsub-back-btn">{{ Dic.backtologin.text }}</a>
	} }
</div>
